import React, { useState } from 'react';
import { Text, View, Image, Pressable, Keyboard, Platform } from 'react-native';
import classes from '../../../../styles/globalClasses';
import gs from '../../../../styles/globalStyles';
import OTPVerification from '@sharedComponents/OTPInput/OTPInput';
import axios from 'axios';
import { X } from '@sharedComponents/Icons';
import { endpoints } from '@api/apis';
import { Typography } from '@app/sharedComponents/typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { getParameters } from '@app/utils';
import {useDarkMode} from '@app/utils';

const iconUrl =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder.png';
interface VerifyEmailOTPProps {
  userDetails: any;
  otpDigitCount: number;
  email: string;
  onClose: () => void;
  onEmailUpdateSuccess: () => void;
  onResendFail: (err:string) => void;
}

const VerifyEmailOTP: React.FC<VerifyEmailOTPProps> = ({
  userDetails,
  otpDigitCount,
  email,
  onClose,
  onEmailUpdateSuccess,
  onResendFail
}) => {
  const [hasError, setHasError] = useState<string>('');
  const [verifying, setVerifying] = useState<boolean>(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const isDarkMode = useDarkMode()

  const submitOtp = (otp: string) => {
    setVerifying(true);
    const url = endpoints.verifyEmailOTP;
    const payload = {
      emailId: email,
      otp,
    };
    axios
      .post(url, payload, { handleFromMF: true })
      .then(res => {
        onEmailUpdateSuccess();
        onClose();
      })
      .catch(err => {
        console.log('err', err);
        setHasError(err.data.message);
        if (
          err?.status === 400 &&
          err?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP'
        ) {
          setIsBlocked(true);
        }
      })
      .finally(() => {
        setVerifying(false);
      });
  };

  const handleOtpInput = (otp: string[]) => {
    if (isBlocked) {
      return;
    }

    const OTP = otp.join('');
    if (OTP.length === otpDigitCount) {
      submitOtp(OTP);
    } else if (OTP.length > 0 && hasError !== '') {
      setHasError('');
    }
  };

  const triggerResendOTP = (): void => {
    setHasError('');
    const url = endpoints.requestEmailOTP;
    const payload = {
      borrowerAccountId: userDetails?.linkedBorrowerAccounts[0]?.accountId,
      emailId: email,
    };
    axios
      .post(url, payload)
      .then(res => {
        console.log('senOTP', res);
      })
      .catch(err => {
        setHasError(err.data.message);
        console.log('err', err);
        if (
          err?.status === 400 &&
          err?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP'
        ) {
          setIsBlocked(true);
          Keyboard.dismiss()
          onResendFail(err?.data?.message)
        }
      });
  };

  return (
    <>
      <View style={[gs.setPadding(16), gs.setMarginTop(8)]}>
        <View style={[gs.flexRow, gs.spaceBetween]}>
          <View
            style={[
              gs.setMarginBottom(16),
            ]}>
          <Typography 
              typeDLS={TypographyTypeDLS.H3S}
              label = {`Enter ${otpDigitCount}-digit OTP`}
              color={ isDarkMode? ColorTokens.White : ColorTokens.Grey_Night}
          /> 
          </View>
        </View>

        <View
          style={[
            gs.flexRow,
            {
              borderRadius: 12,
              borderWidth: 1,
              borderColor: isDarkMode ? '#10964833': '#CFEADA',
              padding: 12,
              backgroundColor: isDarkMode ? '#1096480d':'#F3FAF6',
            },
            gs.setMarginBottom(16),
          ]}>
          <Image source={{ uri: iconUrl }} style={{ width: 40, height: 40 }} />
          <View style={[gs.setMarginLeft(12)]}>
            <Typography 
                    label={'OTP sent to'}
                    fontSize={FontSizeTokens.XS} 
                    fontWeight={'400'}
                    fontFamily={FontFamilyTokens.Inter} 
                    color={ isDarkMode? ColorTokens.White : ColorTokens.Grey_Charcoal}
                    lineHeight={18}
                />
            <View style={{marginTop:3}}>
                <Typography 
                    label={email}
                    fontSize={FontSizeTokens.SM} 
                    fontWeight={'500'}
                    fontFamily={FontFamilyTokens.Inter} 
                    color={ isDarkMode? ColorTokens.White : ColorTokens.Grey_Night}
                    lineHeight={20}
                />
            </View>
          </View>
        </View>
        <OTPVerification
          noOfDigits={otpDigitCount}
          hasError={hasError}
          handleOtpInput={handleOtpInput}
          resendTimerCount={15}
          triggerResendOTP={triggerResendOTP}
          verifying={verifying}
          blockResend={isBlocked}
          isDarkMode={Boolean(isDarkMode)}
        />
      </View>
    </>
  );
};
export default VerifyEmailOTP;
